import { render, staticRenderFns } from "./notification-alert.vue?vue&type=template&id=412bd709"
import script from "./notification-alert.vue?vue&type=script&lang=js"
export * from "./notification-alert.vue?vue&type=script&lang=js"
import style0 from "./notification-alert.vue?vue&type=style&index=0&id=412bd709&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports